<template>
  <div id="app" :class="appClass">
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
/* eslint-disable import/no-unresolved */
import Footer from '@/components/Footer.vue';

export default {
  computed: {
    appClass() {
      switch (Object.keys(this.$route.params).length) {
        default:
          return 'indexPage';
        case 1:
          return 'directoryPage';
        case 2:
          return 'recordPage';
      }
    },
  },
  components: {
    Footer,
  },
};
</script>
